<template>
  <!-- 增值服务管理———组件 -->
  <el-dialog :title="title" :visible.sync="dialogFormVisible" width="500px" @close="close">
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <!-- 名称 -->
      <el-form-item label="名称" prop="name">
        <el-input v-model.trim="form.name" autocomplete="off" placeholder="请输入" maxlength="20"
          show-word-limit></el-input>
      </el-form-item>
      <!-- 价格 -->
      <el-form-item label="价格" prop="price">
        <el-input v-model.trim="form.price" autocomplete="off" placeholder="请输入" @input="handleInputprice"></el-input>
      </el-form-item>
      <!-- 线路 -->
      <el-form-item label="线路" prop="price">
          <el-select v-model="form.kor_type" filterable placeholder="请选择">
              <el-option
                v-for="item in kor_type_list"
                :key="item.type"
                :label="item.name"
                :value="item.type">
              </el-option>
            </el-select>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-radio-group v-model="form.type">
          <el-radio :label="0">普通</el-radio>
          <el-radio :label="1">图片</el-radio>
          <el-radio :label="2">视频</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 状态 -->
      <el-form-item v-if="!isShow" label="状态">
        <el-switch v-model="form.is_delete" :inactive-value="1" :active-value="0"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {
    valid
  } from 'mockjs'
  import {
    serviceDetail,
    serviceUpdate,
    serviceAdd,
    Index_country_list
  } from '@/api/xgcApi'

  export default {
    name: 'ManageStore',
    data() {
      return {
        kor_type_list:[],
        form: {
          is_delete: 0,
          type: 0,
          kor_type:null
        },
        rules: {
          name: [{
            required: true,
            trigger: 'blur',
            message: '请输入名称'
          }],
          price: [{
            required: true,
            trigger: 'blur',
            message: '请输入价格'
          }],
          type: [{
            required: true,
            trigger: 'blur',
            message: '请选择类型'
          }],
        },
        title: '',
        dialogFormVisible: false,
        isShow: true,
      }
    },
    mounted() {

    },
    methods: {

      handleInputprice() {
        // 移除非数字和非小数点字符，保留小数点
        this.form.price = this.form.price
          .replace(/[^\d.]/g, '')
          // 保留第一个小数点，移除其他小数点
          .replace(/^(\d*\.)(.*)\./g, '$1$2')
          // 移除前导零，但保留小数点前的单个零
          .replace(/^0+(\d+\.{0,1}\d*)/, '$1')
      },
      async showEdit(row) {
        Index_country_list({}).then(req => {
            this.kor_type_list = req.data
            if (!row) {
              this.title = '添加'
              this.isShow = false
              this.dialogFormVisible = true
            } else {
              this.isShow = true
              this.title = '编辑'
              serviceDetail({
                id: row.id
              }).then(res => {
                var data = res.data
                this.form = data
                console.log(this.form)
                this.dialogFormVisible = true
              })
            }
        })


      },
      close() {
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
        this.dialogFormVisible = false
      },
      save() {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            if (this.isShow == false) {
              const {
                msg
              } = await serviceAdd(this.form)
              this.$baseMessage(msg, 'success')
              this.$refs['form'].resetFields()
              this.dialogFormVisible = false
              this.$emit('fetch-data')
              this.form = this.$options.data().form
            } else {
              const {
                msg
              } = await serviceUpdate(this.form)
              this.$baseMessage(msg, 'success')
              this.$refs['form'].resetFields()
              this.dialogFormVisible = false
              this.$emit('fetch-data')
              this.form = this.$options.data().form
            }
          } else {
            return false
          }
        })
      },
    },
  }
</script>
